import React from "react";
import {Form, Input, Tooltip} from "antd";

export default class LeakyBucketRateLimiter extends React.Component<any, any> {
    render() {
        return (
            <>
                <Tooltip title={"这是路由每秒所能允许的最大请求数量"}>
                    <Form.Item label={"每秒最大请求"} name={"maxReqPerSec"} wrapperCol={{span: 7}}>
                        <Input type={"number"} min={0} placeholder={"每秒最大请求"}/>
                    </Form.Item>
                </Tooltip>
                <Tooltip title={"这是网关向后端服务放行请求的速率"}>
                    <Form.Item label={"请求放行速率"} name={"avgReqPerSec"} wrapperCol={{span: 7}}>
                        <Input type={"number"} min={0}/>
                    </Form.Item>
                </Tooltip>
            </>
        );
    }
}
